import type { ReactNode } from 'react';
import { EditorSyncStatusContext } from './EditorSyncStatusContext';

export function EditorSyncStatusProvider({
  isSyncing,
  children,
}: {
  isSyncing: boolean;
  children: ReactNode;
}) {
  return (
    <EditorSyncStatusContext.Provider value={isSyncing}>{children}</EditorSyncStatusContext.Provider>
  );
}
